module.exports = __webpack_public_path__ + "static/media/WVA200229010.265080f2.pdf";